import { LayoutHeader } from '@/components/domains/layouts'
import PolicyBeforePrivacy from '@/components/domains/policy/PolicyBeforePrivacy20260529'

const PagePolicyBeforePrivacy20260529 = () => {
  return (
    <>
      <LayoutHeader />
      <PolicyBeforePrivacy />
    </>
  )
}

export default PagePolicyBeforePrivacy20260529
